import { DropdownChevron } from "components/components/Icon/Icon";
import { DropdownIndicatorProps, components } from "react-select";
import colours from "styles/colours";

export function DropdownIndicator<Option, IsMulti extends boolean>(
  props: DropdownIndicatorProps<Option, IsMulti>
): JSX.Element | null {
  if (!components.DropdownIndicator) {
    return null;
  }

  return (
    <components.DropdownIndicator {...props}>
      <DropdownChevron
        colour={colours.elexonBlue}
        className="elx-select-chevron"
      />
    </components.DropdownIndicator>
  );
}
